var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamaskCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2091 7L15.957 12.0013L17.1182 9.05067L22.2091 7Z",
    fill: "#E17726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79102 7L13.9862 12.0487L12.882 9.05067L7.79102 7Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.962 18.5942L18.2988 21.3422L21.8577 22.3976L22.8748 18.6549L19.962 18.5942Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13184 18.6549L8.14273 22.3976L11.7016 21.3422L10.0446 18.5942L7.13184 18.6549Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5064 13.9506L10.5146 15.5686L14.0426 15.7379L13.9233 11.6426L11.5064 13.9506Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4932 13.9505L16.0386 11.5952L15.957 15.7379L19.485 15.5685L18.4932 13.9505Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7012 21.3421L13.8293 20.2248L11.9961 18.6821L11.7012 21.3421Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1704 20.2248L18.2986 21.3421L18.0036 18.6821L16.1704 20.2248Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2986 21.3419L16.1704 20.2246L16.3398 21.7206L16.3213 22.3499L18.2986 21.3419Z",
    fill: "#D5BFB2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7012 21.3419L13.6784 22.3499L13.6661 21.7206L13.8293 20.2246L11.7012 21.3419Z",
    fill: "#D5BFB2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7164 17.6934L11.9463 17.1321L13.1952 16.5161L13.7164 17.6934Z",
    fill: "#233447"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2837 17.6934L16.8049 16.5161L18.06 17.1321L16.2837 17.6934Z",
    fill: "#233447"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7014 21.3422L12.0087 18.5942L10.0444 18.6549L11.7014 21.3422Z",
    fill: "#CC6228"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9912 18.5942L18.2985 21.3422L19.9617 18.6549L17.9912 18.5942Z",
    fill: "#CC6228"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.485 15.5688L15.957 15.7382L16.2835 17.6935L16.8047 16.5162L18.0598 17.1322L19.485 15.5688Z",
    fill: "#CC6228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.946 17.1322L13.1949 16.5162L13.7161 17.6935L14.0426 15.7382L10.5146 15.5688L11.946 17.1322Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5146 15.5688L11.9961 18.6822L11.946 17.1322L10.5146 15.5688Z",
    fill: "#E27525"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0602 17.1322L18.0039 18.6822L19.4853 15.5688L18.0602 17.1322Z",
    fill: "#E27525"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0428 15.7378L13.7163 17.6931L14.1306 20.0011L14.2184 16.9625L14.0428 15.7378Z",
    fill: "#E27525"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.957 15.7378L15.7876 16.9558L15.8692 20.0011L16.2835 17.6931L15.957 15.7378Z",
    fill: "#E27525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2834 17.6932L15.8691 20.0012L16.1702 20.2245L18.0035 18.6818L18.0597 17.1318L16.2834 17.6932Z",
    fill: "#F5841F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9463 17.1318L11.9964 18.6818L13.8296 20.2245L14.1307 20.0012L13.7164 17.6932L11.9463 17.1318Z",
    fill: "#F5841F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.321 22.3498L16.3396 21.7205L16.1831 21.5718H13.8163L13.6661 21.7205L13.6784 22.3498L11.7012 21.3418L12.3918 21.9505L13.7978 22.9998H16.2017L17.6077 21.9505L18.2983 21.3418L16.321 22.3498Z",
    fill: "#C0AC9D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1706 20.2248L15.8695 20.0015H14.1308L13.8297 20.2248L13.6665 21.7208L13.8167 21.5721H16.1835L16.34 21.7208L16.1706 20.2248Z",
    fill: "#161616"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4726 12.3267L23 9.56533L22.2092 7L16.1704 11.8327L18.4933 13.9507L21.7758 14.9867L22.4979 14.0727L22.1839 13.8293L22.6859 13.3347L22.3032 13.01L22.8052 12.5973L22.4726 12.3267Z",
    fill: "#763E1A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.56533L7.53358 12.3267L7.19476 12.5973L7.69681 13.01L7.31409 13.3347L7.81614 13.8293L7.50205 14.0727L8.22421 14.9867L11.5067 13.9507L13.8296 11.8327L7.79079 7L7 9.56533Z",
    fill: "#763E1A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7761 14.9867L18.4936 13.9507L19.4853 15.5687L18.0039 18.682L19.962 18.6547H22.8748L21.7761 14.9867Z",
    fill: "#F5841F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5068 13.9507L8.22435 14.9867L7.13184 18.6547H10.0446L11.9965 18.682L10.5151 15.5687L11.5068 13.9507Z",
    fill: "#F5841F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 15.7381L16.1705 11.8328L17.1183 9.05078H12.8818L13.8297 11.8328L14.043 15.7381L14.1246 16.9694L14.1308 20.0014H15.8694L15.8756 16.9694L15.9572 15.7381Z",
    fill: "#F5841F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskCircleIcon);
export default __webpack_public_path__ + "static/media/metamask-circle-icon.0c3e3a20fe994abe2df4878c9217f6fb.svg";
export { ForwardRef as ReactComponent };